import React from "react";
import Layout from "../../layout/adminExt/Layout";
import ExtFeedbacks from "./ExtFeedbacks";

export default function Index() {
  return (
    <Layout>
      <ExtFeedbacks />
    </Layout>
  );
}
